module.exports = __webpack_public_path__ + "static/media/download.bf9f384a.svg";